module.exports = __webpack_public_path__ + "media/images/down_arrow-ee039e70bc2578cb741bded0c8d5fd96.png";